import gql from 'graphql-tag';

import googleDriveRemoteItemsPageFragment from '../fragments/googleDriveRemoteItemsPageFragment';

export const queryGoogleDriveRemoteItemsPage = gql`
  query googleDriveRemoteItemsPage(
    $credentialID: DokkioID!
    $parentFolderRemoteID: String
    $sharedDriveID: ID
    $pageToken: String
    $sharedWithMe: Boolean
  ) {
    googleDriveRemoteItemsPage(
      credentialID: $credentialID
      parentFolderRemoteID: $parentFolderRemoteID
      sharedDriveID: $sharedDriveID
      pageToken: $pageToken
      sharedWithMe: $sharedWithMe
    ) {
      ...googleDriveRemoteItemsPageFragment
    }
  }
  ${googleDriveRemoteItemsPageFragment}
`;

export default queryGoogleDriveRemoteItemsPage;
